module.exports = __webpack_public_path__ + "media/images/flags/in-af9784228aaea5c8be6efdd3b849c4f4.png";